// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"46bf6529f809a5d2e436","678":"fdc372d0d4f74efe1f57"}[chunkId] + ".js";
};